var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useLucidSdk } from '#context';
import { WorkspacesKeyFactory } from '../../query-key-factories';
export const useWorkspaceMarkOnboardingAsCompleted = (workspaceId, { onError, onSuccess }) => {
    _react_refresh_temp_1();
    const { lucidSdk } = useLucidSdk();
    const queryClient = useQueryClient();
    const mutation = useMutation({
        mutationFn: () => lucidSdk
            .workspacesManagement()
            .markWorkspaceOnboardingAsCompleted(workspaceId),
        onSuccess: async () => {
            try {
                // WorkspaceData must be reloaded,
                // so that it respects the onboarding process status change
                await queryClient.refetchQueries({
                    exact: true,
                    queryKey: WorkspacesKeyFactory.byWorkspacePoll(workspaceId),
                });
            }
            finally {
                if (typeof onSuccess === 'function') {
                    onSuccess();
                }
            }
        },
        onError: (error) => {
            if (typeof onError === 'function') {
                onError(error);
            }
        },
        networkMode: 'always',
    });
    return {
        mutation,
    };
};
_react_refresh_temp_1(useWorkspaceMarkOnboardingAsCompleted, "s074ag8lSG2K0z8InO7Yl75Raxc=", false, () => [useLucidSdk, useQueryClient, useMutation]);
